import _ from 'lodash';
import { of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { ACTIVITY_TYPE } from '../virtual-event.enums';

export class AcitivityEntity {
    public index: number = null;
    public type: any = null;
    public data: any = null;
    public timestamp: number = null;
    public attendeeType: number = null;
    public inPersonPaddleNum: number = null;

    public timer$ = timer(1000, 5000).pipe(
        mergeMap(this.getTimerValue.bind(this))
    );

    constructor(data: any) {
        this.index = data.index;
        this.type = data.type;

        this.timestamp = data.actionTime;
        this.attendeeType = data.attendeeType || 0;
        this.inPersonPaddleNum = data.inPersonPaddleNum || 0;

        switch(this.type) {
            case ACTIVITY_TYPE.PLEDGE:
                const campaignType = _.get(data, 'campaign.type', 0);
                const campaignDataType = _.get(data, 'campaignData.type', campaignType);
                this.type = campaignDataType === 4 ? 'sold': 'pledge';
            case ACTIVITY_TYPE.BID:
                this.data = {
                    amount: data.amount,
                    name: data.donor.name
                }
                break;
            case ACTIVITY_TYPE.DECLARE_WINNER:
            case ACTIVITY_TYPE.DECLARE_LAST_HERO:
            case ACTIVITY_TYPE.CAMPAIGN_CHANGE:
            case ACTIVITY_TYPE.SILENT_AUCTION_CLOSED:
                const action = _.get(data, 'action', null);
                const type = _.get(data, 'type', null);
                if(action === 7 &&  type === 4) {
                    this.type = 'sold';
                    this.data = {
                        amount: data.amount,
                        name: data.donor.name
                    }
                } else {
                    this.data = {
                        name: data.name
                    }
                }
                break;
            case ACTIVITY_TYPE.SELL_MORE:
                this.data = {
                    amount: data.amount,
                    name: data.name
                }
                break;
            case ACTIVITY_TYPE.RECURRING:
                this.type = 'recurring';
                this.data = {
                    amount: data.amount,
                    name: data.donor.name
                }
                break;
        }
    }

    getTimerValue() {
        let result = Math.round(new Date().getTime()/1000) - this.timestamp;
        return of(result);
    }
}
